import gif1 from "../../../../src/articles/Settings/Crosshair/gi1.gif";
import gif2 from "../../../../src/articles/Settings/Crosshair/gi2.gif";
import * as React from 'react';
export default {
  gif1,
  gif2,
  React
};